import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5725d381"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: _ctx.formModel,
    "label-width": _ctx.labelWidth,
    ref: "formRef"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, rowIndex) => {
        return (_openBlock(), _createBlock(_component_el_row, {
          key: rowIndex,
          gutter: _ctx.gutter,
          justify: "justify"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                key: index,
                span: _ctx.isFullRow(item) ? 24 : _ctx.colSpan
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: item.columnName,
                    class: _normalizeClass({ 'is-full-row': _ctx.isFullRow(item) }),
                    "label-width": item.component != 'DynamicJsonForm'?_ctx.labelWidth:'0px',
                    label: item.component != 'DynamicJsonForm'?item.columnComment:'',
                    rules: _ctx.formatRules(item)
                  }, {
                    default: _withCtx(() => [
                      (_ctx.roleIds.indexOf(item.oprRoles) !== -1 && _ctx.canEdit)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (item.component != 'DynamicJsonForm')
                              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent(item)), _mergeProps({
                                  key: 0,
                                  ref_for: true
                                }, _ctx.formatOptions(item), {
                                  modelValue: _ctx.formModel[item.columnName],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.formModel[item.columnName]) = $event),
                                  "form-model": _ctx.formModel
                                }), null, 16, ["modelValue", "onUpdate:modelValue", "form-model"]))
                              : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent(item)), _mergeProps({
                                  key: 1,
                                  field: item.columnName,
                                  title: item.columnComment,
                                  "can-edit": _ctx.canEdit,
                                  "label-width": _ctx.labelWidth,
                                  columns: _ctx.columns,
                                  "role-ids": _ctx.roleIds,
                                  "col-span": _ctx.colSpan,
                                  ref_for: true
                                }, _ctx.formatOptions(item), {
                                  model: _ctx.formModel[item.columnName],
                                  "onUpdate:model": _ctx.handleUpdateJson
                                }), null, 16, ["field", "title", "can-edit", "label-width", "columns", "role-ids", "col-span", "model", "onUpdate:model"]))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (item.component != 'DynamicJsonForm')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.formatViewValue(item)), 1))
                              : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent(item)), _mergeProps({
                                  key: 1,
                                  field: item.columnName,
                                  title: item.columnComment,
                                  "can-edit": false,
                                  "label-width": _ctx.labelWidth,
                                  columns: _ctx.columns,
                                  "role-ids": _ctx.roleIds,
                                  "col-span": _ctx.colSpan,
                                  ref_for: true
                                }, _ctx.formatOptions(item), {
                                  model: _ctx.formModel[item.columnName],
                                  "onUpdate:model": _ctx.handleUpdateJson
                                }), null, 16, ["field", "title", "label-width", "columns", "role-ids", "col-span", "model", "onUpdate:model"]))
                          ], 64))
                    ]),
                    _: 2
                  }, 1032, ["prop", "class", "label-width", "label", "rules"])
                ]),
                _: 2
              }, 1032, ["span"]))
            }), 128))
          ]),
          _: 2
        }, 1032, ["gutter"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["model", "label-width"]))
}